import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ContractsService } from '@api/contracts.service';
import { SelectedExtraServiceData } from '@shared/model/extras-services.model';
import { ExtraServiceResponseData } from '@shared/model/extraservices.model';
import { log } from 'console';
import { environment } from 'environments/environment';
import jalaliMoment = require('jalali-moment');
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-view-response',
  templateUrl: './view-response.component.html',
  styleUrls: ['./view-response.component.scss']
})
export class ViewResponseComponent implements OnInit {
  public language = 'fa';
  responseDetail = [];
  public requestDetailForm: FormGroup;
  serviceTypeId;
  fromDate;
  isDocument: boolean;
  toDate;
  routePage: boolean;
  response: any;
  providerId: string;
  baseUrl = environment.baseUrl;
  extraServicesProvider: SelectedExtraServiceData[] = [];
  requestId: number;
  extraServices: ExtraServiceResponseData[] = [];
  public destroy$ = new Subject<void>();
  itemContainer = false;
  public serviceType = [
    { label: 'حمل و نقل', values: 0 },
    { label: 'ترخیص', values: 1 },
    { label: 'حمل و نقل و ترخیص', values: 2 },
  ];
  private subscription = new Subscription();

  constructor(
    private formBuilder: FormBuilder,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private contractsService: ContractsService
  ) {
    this.requestDetailForm = this.formBuilder.group({
      selectedExtraServices: this.formBuilder.array([]),
    });
  }
  ngOnInit() {
    const url = this.router.url;
    this.requestId = this.activatedRoute.snapshot.params.requestId;
    this.providerId = this.activatedRoute.snapshot.params.providerId;
    this.getDataDeomApi();
    this.getServiceTypeId();
  }

  getDataDeomApi() {
    this.subscription = this.contractsService
      .getContractResponse(this.requestId, +this.providerId)
      .subscribe((res: any) => {
        if (res) {
          this.responseDetail.push(res);
          this.responseDetail[0].arriveDate = jalaliMoment(this.responseDetail[0].arriveDate?.resValue).format('jYYYY/jMM/jDD hh:mm');
          this.responseDetail[0].departureDate = jalaliMoment(this.responseDetail[0].departureDate?.resValue).format('jYYYY/jMM/jDD hh:mm');
          this.responseDetail[0].expiryDate = jalaliMoment(this.responseDetail[0].expiryDate).format('jYYYY/jMM/jDD hh:mm');

          this.getInitialValue(res);
        }
      });
  }

  createServices(): FormGroup {
    return this.formBuilder.group({
      id: Number,
      enTitle: String,
      faTitle: String,
      isChecked: Boolean,
      oldValue: Boolean,
      newValue: Boolean,
    });
  }

  getImageUrl(url: string) {
    if (url) {
      return `${this.baseUrl}/${url}`;
    }
    if (!url) {
      return 'assets/img/no-image.jpg';
    }
  }

  getInitialValue(response) {
    this.response = response;
    if (this.response) {
      if (this.response.selectedExtraServices.isChanged === false) {
        const selectedExtraService = this.response.selectedExtraServices.resValue;
        this.isDocument = !response?.goods[0].hsCode?.id;
        const express = response?.isExpress === true ? 1 : 0;
        const document = response?.isDocument === true ? 1 : 0;
        const serviceType = response?.serviceTypeId;
        // const transportType = response?.transportTypeId?.id === 1 ? 1 : 0;
        this.http.get(`${environment.baseUrl}/api/v1/base-info/extra-services?serviceType=${serviceType}&express=${express}&document=${document}`)
          .subscribe((res: any) => {
            this.extraServices = res.data;
            if (this.isDocument) {
              for (let i = 0; i < this.extraServices.length; i++) {
                if (this.extraServices[i].enTitle === 'Inspection services') {
                  this.extraServices.splice(i, 1);
                }
                if (this.extraServices[i].enTitle === 'Obtaining a license') {
                  this.extraServices.splice(i, 1);
                }
                if (this.extraServices[i].enTitle === 'Warehousing') {
                  this.extraServices.splice(i, 1);
                }
                if (this.extraServices[i].enTitle === 'Payment services') {
                  this.extraServices.splice(i, 1);
                }
                if (this.extraServices[i].enTitle === 'sourcing and Purchase order') {
                  this.extraServices.splice(i, 1);
                }
                if (this.extraServices[i].enTitle === 'order registration') {
                  this.extraServices.splice(i, 1);
                }
              }
            }
            this.extraServices.map((_: any) => {
              _.isChecked = false;
              return _;
            });
            const selectedExtraServiceId = selectedExtraService.map(
              (_) => _.id
            );
            this.extraServices.map((_) => {
              selectedExtraServiceId.includes(_.id)
                ? (_.isChecked = true)
                : (_.isChecked = false);
              return _;
            });
            const formServices = this.requestDetailForm.get(
              'selectedExtraServices'
            ) as FormArray;
            this.extraServices.map((item, i) => {
              formServices.push(this.createServices());
              formServices.controls[i].patchValue(item);
            });
          });
      } else if (this.response.selectedExtraServices.isChanged === true) {
        const selectedExtraService = this.response.selectedExtraServices.resValue;
        this.isDocument = !response?.goods[0].hsCode?.id;
        const express = response?.isExpress === true ? 1 : 0;
        const document = response?.isDocument === true ? 1 : 0;
        const serviceType = response?.serviceTypeId
        this.http.get(
          `${environment.baseUrl}/api/v1/base-info/extra-services?serviceType=${response?.serviceTypeId}&express=${express}&document=${document}`)
          .subscribe((res: any) => {
            this.extraServices = res.data;
            if (this.isDocument) {
              for (let i = 0; i < this.extraServices.length; i++) {
                if (this.extraServices[i]?.enTitle === 'Inspection services') {
                  this.extraServices.splice(i, 1);
                }
                if (this.extraServices[i]?.enTitle === 'Obtaining a license') {
                  this.extraServices.splice(i, 1);
                }
                if (this.extraServices[i]?.enTitle === 'Warehousing') {
                  this.extraServices.splice(i, 1);
                }
                if (this.extraServices[i]?.enTitle === 'Payment services') {
                  this.extraServices.splice(i, 1);
                }
                if (this.extraServices[i]?.enTitle === 'sourcing and Purchase order') {
                  this.extraServices.splice(i, 1);
                }
                if (this.extraServices[i]?.enTitle === 'order registration') {
                  this.extraServices.splice(i, 1);
                }
              }
            }
            this.extraServices.map((_: any) => {
              _.isChecked = false;
              return _;
            });
            const selectedExtraServiceId = selectedExtraService.map((_) => _.id);
            this.extraServices.map((_) => {
              selectedExtraServiceId.includes(_.id)
                ? (_.isChecked = true)
                : (_.isChecked = false);
              return _;
            });
            const formServices = this.requestDetailForm.get(
              'selectedExtraServices'
            ) as FormArray;
            this.extraServices.map((item, i) => {
              formServices.push(this.createServices());
              formServices.controls[i].patchValue(item);
            });
          });
      }
    }
  }

  getServiceTypeId() {
    switch (this.serviceTypeId) {
      case 0:
        this.fromDate = 'fromDateTransport';
        this.toDate = 'toDateTransport';
        break;
      case 1:
        this.fromDate = 'fromDateClearance';
        this.toDate = 'toDateClearance';
        break;
      case 2:
        this.fromDate = 'fromDateBoth';
        this.toDate = 'toDateBoth';
        break;
    }
  }
  get selectedExtraServices(): FormArray {
    return this.requestDetailForm.controls.selectedExtraServices as FormArray;
  }

  numberWithCommas(e, formControl) {
    const value = e.target.value;
    this.requestDetailForm.controls[formControl].setValue(
      value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    );
  }

  convertToCommas(x) {
    const value = Math.trunc(x);
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }


  changeCaption(oldCaption: string) {
    return oldCaption?.replace(/\n/g, '</br>');
  }
}

